import { FC } from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import { Rw1Logo } from "../icons/Rw1Logo";
import { Rw1LogoColored } from "../icons/RW1LogoColored";

export const LoadingPage: FC = () => {
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100dvh",
        width: "100dvw",
      }}
    >
      {isMobile ? (
        <Rw1Logo width="20dvw" />
      ) : (
        <Rw1LogoColored color="text.1" height="5dvw" />
      )}
    </div>
  );
};
